import React, { useMemo } from 'react';
import { ArrowForward } from "../../../icons";
import { getTestIds } from "../../../utils/TestIds";
import { ConditionalWrapper } from "../../ConditionalWrapper";
import { useIntentBehavior } from "../../IntentBehavior";
import { Tooltip } from "../../Tooltip";
import { Typography } from "../../Typography";
import styles from "./MenuPromotionalAction.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetMenuPromotionalActionTID = parentTestId => getTestIds(parentTestId);
export function MenuPromotionalAction(props) {
  const {
    title,
    body,
    testId,
    intent,
    onClick,
    onMouseDown
  } = props;
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const {
    MenuPromotionalActionTID
  } = useMemo(() => GetMenuPromotionalActionTID(testId), [testId]);
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: !!tooltipFromIntent,
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, {
      "data-testid": MenuPromotionalActionTID.Tooltip(),
      placement: "top",
      title: tooltipFromIntent || '',
      children: /*#__PURE__*/_jsx("div", {
        children: children
      })
    }),
    children: /*#__PURE__*/_jsxs("button", {
      className: styles.root,
      "data-testid": MenuPromotionalActionTID.Root(),
      disabled: disabledFromIntent,
      onClick: onClick,
      onMouseDown: onMouseDown,
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Typography, {
          weight: "normal",
          skin: "primary",
          variant: "paragraph1",
          children: title
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          weight: "light",
          children: body
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.iconWrapper,
        children: /*#__PURE__*/_jsx(ArrowForward, {})
      })]
    })
  });
}